import CenteredBox from "../common/CenteredBox";
import { CustomLoginCallback } from "./LoginCallback";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

export default function LoginCallbackScreen() {
  return (
    <CenteredBox>
      <CustomLoginCallback
        errorComponent={({ label, message }) => {
          console.log(`${label}: ${message}`);
          return (
            <pre>
              {label} - {message}
            </pre>
          );
        }}
        loadingElement={
          <HourglassBottomIcon fontSize="large" sx={{ textAlign: "center" }} />
        }
      />
    </CenteredBox>
  );
}
